import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  Modal,
  Stack,
  TextareaAutosize,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import InputField from "../Common/InputField";
import CommonButton from "../Common/CommonButton";
import OtpModal from "../Common/OtpModal";
import TextArea from "../Common/TextArea";
import VerificationModal from "../Common/VerificationModal";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import WifiCalling3Icon from "@mui/icons-material/WifiCalling3";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ChatIcon from "@mui/icons-material/Chat";
import { tabs } from "../../App";
import { useTranslation } from "react-i18next";
import { Select } from "@mui/base";
import Dropdown from "../Common/Select";
import person from "../../assets/person.svg";
import phone from "../../assets/Group.svg";
import msg from "../../assets/msg.svg";
import clipboardCopy from 'clipboard-copy';

// import LocationOnIcon from "@material-ui/icons/LocationOn";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { toast } from "react-toastify";
import ReCAPTCHA from 'react-google-recaptcha';

const CustomerDetails = ({
  selectedTab,
  setSelectedTab,
  openOtpModal,
  handleCloseOtpModal,
  selectedLanguage,
  setOtpConfirmed,
  username,
  email,
  contactNumber,
  secondaryOption,
  setName,
  setEmail,
  setContactNumber,
  setSecondaryOption,
  getOTP,
  orderDetails,
  notes,
  setNotes,
  otp,
  verifyOtp,
  selectedLocationId,
  selectedTime,
  estTime,
  formattedDate,
  bookingAmount,
  bookingParams,
  setVerifyOtp,
  otpConfirmed,
  enablePayment,
  setEnablePayment,
}) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const { t } = useTranslation();
  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef();
  const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  const [modalOpen, setModalOpen] = useState(false);
  const [isOtpLoading, setIsOtpLoading] = useState(false);
  const minimumBookingTime = bookingParams?.[0]?.minimum_booking_time;
  const [phoneNumber, setPhoneNumber] = useState(
    contactNumber ? contactNumber.substring(4) : ""
  );
  const [phoneNumberError, setPhoneNumberError] = useState("");
//  useEffect(()=>{
//   navigator.clipboard.writeText("")

//  },[])
const onCaptchaChange = (token) => {
  setCaptchaToken(token); 
};

const handleOpenModal = async () => {
  if (isOtpLoading) return;

  clipboardCopy('');

  const numberRegex = /^\d+$/;

  if (username === "") {
    return toast.error("Please enter your name.");
  }

  if (!numberRegex.test(contactNumber)) {
    return toast.error("Please enter a valid contact number.");
  }

  if (contactNumber.length !== 8) {
    return toast.error("Contact number should be 8 digits.");
  }

  if (selectedTime === "") {
    return toast.error("Please select a time slot");
  }

  if (!recaptchaSiteKey) {
    return toast.error("reCAPTCHA site key is not configured.");
  }

  if (!captchaToken) {
    return toast.error("Please complete the captcha");
  }

  if (selectedLocationId === "") {
    return toast.error("Please select a location");
  }

  if (estTime < minimumBookingTime) {
    return toast.error("Estimated time is less than minimum booking time.");
  }

  setIsOtpLoading(true);
  try {
    const response = await getOTP(captchaToken);

    // getOTP returns the axios response on success, or the axios error object on failure
    const status = response?.status ?? response?.response?.status;
    const data   = response?.data   ?? response?.response?.data;

    switch (status) {
      case 200:
        toast.success(data?.message || "OTP sent on your primary number");
        setModalOpen(true);
        break;
      case 400:
        toast.error(data?.message || "Invalid request. Please try again.");
        break;
      case 429:
        toast.warning(data?.message || data?.detail || "Too many attempts. Please wait before trying again.");
        break;
      case 500:
        toast.error(data?.message || "Server error. Please try again later.");
        break;
      default:
        toast.error("Request failed. Please try again.");
    }
  } catch (err) {
    toast.error("Request failed. Please try again.");
  } finally {
    setIsOtpLoading(false);
    setCaptchaToken(null);
    recaptchaRef.current?.reset();
  }
};

  const handleCloseModal = (event, reason) => {
    setModalOpen(false);
    setEnablePayment(verifyOtp);
    orderDetails();
  };
  const handleClosee = (event, reason) => {
    // if (reason && reason == "backdropClick") {
    //   return;
    // }
    setModalOpen(false);
  
  };
 


  const handleClick = () => {
    const url =
      selectedLanguage === "ar"
        ? "https://bishkar.com/terms-conditions"
        : "https://bishkar.com/terms-conditions-ar";
    window.location.href = url;
  };
  return (
    <>
      <Box
        sx={{
          height: isMobile ? "calc(100dvh - 380px)" : "410px",
          overflowY: "auto",
          overflowX: "hidden",
          // padding: "0px 9px 0px 9px",
          // overflow: "hidden",
          position: "relative",
          scrollbarColor: "transparent transparent",
          "&::-webkit-scrollbar": {
            display: " none",
          },
        
        }}
      >
        {/* <OtpModal open={openOtpModal} handleClose={handleCloseOtpModal} /> */}
        <Box sx={{ position: "absolute" }}>
          <OtpModal
            open={modalOpen}
            handleClose={handleCloseModal}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
            setVerifyOtp={setVerifyOtp}
            verifyOtp={verifyOtp}
            handleClosee={handleClosee}
          />
        </Box>

        <Grid container rowSpacing={1} columnSpacing={1}>
          <Grid item md={6} xs={12}>
            <InputField
              label={t("yourName")}
              selectedLanguage={selectedLanguage}
              icon={PersonOutlineOutlinedIcon}
              value={username}
              setState={setName}
              image={person}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <InputField
              label={t("yourNumber")}
              selectedLanguage={selectedLanguage}
              icon={WifiCalling3Icon}
              // value={`+987 ${contactNumber}`}
              // setState={setContactNumber}
              value={contactNumber}
              setState={(value) => setContactNumber(value)}
              image={phone}
              includeCountryCode={true}
              countryCodeEditable={true}
            />
          </Grid>
          {!isMobile ? (
            <>
              <Grid item md={6} xs={12}>
                <InputField
                  selectedLanguage={selectedLanguage}
                  label={t("yourEmail")}
                  icon={MailOutlineIcon}
                  value={email}
                  setState={setEmail}
                  image={msg}
                  includeEmail={true}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <InputField
                  selectedLanguage={selectedLanguage}
                  label={t("secondaryNumber")}
                  icon={WifiCalling3Icon}
                  value={secondaryOption}
                  // value={`+987 ${phoneNumber}`}
                  image={phone}
                  setState={(value) => setSecondaryOption(value)}
                  includeCountryCode={true}
                  countryCodeEditable={true}
                  includeEmail2={true}
                />
              </Grid>
            </>
          ) : (
            <>
              <Grid item md={6} xs={12}>
                <InputField
                  selectedLanguage={selectedLanguage}
                  label={t("secondaryNumber")}
                  icon={WifiCalling3Icon}
                  value={secondaryOption}
                  setState={(value) => setSecondaryOption(value)}
                  includeCountryCode={true}
                  countryCodeEditable={true}
                  image={phone}
                  includeEmail2={true}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <InputField
                  selectedLanguage={selectedLanguage}
                  label={t("yourEmail")}
                  icon={MailOutlineIcon}
                  value={email}
                  setState={setEmail}
                  image={msg}
                  includeEmail={true}
                />
              </Grid>
            </>
          )}

          {!isMobile && (
            <>
              <Grid item>
                <Box></Box>
              </Grid>
              <Grid 
              item
  className="verifygrid"
  md={12}
  xs={12}
  sx={{
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: "8px !important",
    alignItems: "center", // optional to center vertically
  }}
>
  <Box
    sx={{
      transform: "scale(0.85)", 
      transformOrigin: "left center", 
    }}
  >
    {recaptchaSiteKey ? (
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={recaptchaSiteKey}
        onChange={onCaptchaChange}
      />
    ) : (
      <Typography color="error" sx={{ fontSize: 12 }}>
        reCAPTCHA is not configured
      </Typography>
    )}
  </Box>

  <Box sx={{ margin: "10px 0px 10px 0px" }}>
    <Button
      disabled={otpConfirmed || isOtpLoading || !recaptchaSiteKey}
      style={{
        color: "white",
        fontFamily: "Cairo",
        letterSpacing: selectedLanguage !== "ar" ? "1px" : "",
        padding: "12px 26px",
        fontSize: "12px",
        backgroundColor: otpConfirmed ? "#018968" : "#084F8C",
        borderRadius: "25px",
        fontWeight: "700",
        whiteSpace: "nowrap",
        width: "150px",
        opacity: isOtpLoading ? 0.7 : 1,
      }}
      onClick={handleOpenModal}
    >
      {isOtpLoading
        ? <CircularProgress size={18} sx={{ color: "white" }} />
        : otpConfirmed ? t("otpVerify") : t("verifyWithOtp")}
    </Button>
  </Box>
</Grid>

            </>
          )}

          <Grid item md={12} xs={12}>
            <TextArea
              selectedLanguage={selectedLanguage}
              label={t("yourComment")}
              icon={MailOutlineIcon}
              notes={notes}
              setNotes={setNotes}
              // selectedLanguage={selectedLanguage}
             
            />
          </Grid>
          {isMobile && (
            <>
              <Grid
                item
                md={12}
                xs={12}
                display="flex"
                alignItems="center"
                justifyContent="center"
                width="350px"
                marginTop="20px  !important"
                // marginBottom="50px !important"
              >
                {recaptchaSiteKey ? (
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={recaptchaSiteKey}
                    onChange={onCaptchaChange}
                  />
                ) : (
                  <Typography color="error" sx={{ fontSize: 12 }}>
                    reCAPTCHA is not configured
                  </Typography>
                )}
                <Stack
                  direction="column"
                  position="fixed"
                  bottom="80px"
                  padding="10px 1px 0px 1px"
                  sx={{backgroundColor:"#FAFAFA",zIndex:"10"}}
                >
                  
                  <Button
                    disabled={otpConfirmed || isOtpLoading || !recaptchaSiteKey}
                    sx={{ padding: "10px" }}
                    style={{
                      color: "white",
                      fontFamily: "Cairo",
                      letterSpacing: selectedLanguage !== "ar" ? "1px" : "",
                      // padding: "14px 20px",
                      // padding: "10px !important",
                      marginTop: "5px",
                      fontSize: "16px",
                      // backgroundColor: "#084F8C",
                      backgroundColor: otpConfirmed
                        ? "#018968"
                        : "#084F8C",

                      borderRadius: "25px",
                      fontWeight: "700",
                      whiteSpace: "nowrap",
                      width: "345px",
                      opacity: isOtpLoading ? 0.7 : 1,
                    }}
                    onClick={handleOpenModal}
                  >
                  {isOtpLoading
                    ? <CircularProgress size={22} sx={{ color: "white" }} />
                    : otpConfirmed ? t("otpVerify") : t("verifyWithOtp")}
                  </Button>
                  <Box sx={{ marginTop: "5px" ,padding:"10px 0px 35px 0px"}}>
                    <FormControlLabel
                      className={
                        selectedLanguage === "ar"
                          ? "checkbox-ctrl"
                          : "checkbox-ctrl1"
                      }
                      control={
                        <Checkbox
                          defaultChecked
                          sx={{
                            color: "#00DFC9 !important",
                            borderRadius: "6px",
                          }}
                        />
                      }
                      // label="I agree to the terms and conditions"
                      label={
                        // <Typography variant="body1">
                        //   {selectedLanguage === "ar"
                        //     ? I agree to the <strong>Terms and Conditions</strong>
                        //     : ""}
                        // </Typography>
                        <Typography variant="body1" >
                          {selectedLanguage !== "ar" ? "I agree to the " : ""}
                          {selectedLanguage !== "ar" ? (
                            <strong onClick={handleClick} className="terms-hover">Terms and Conditions</strong>
                          ) : (
                            <>
                           <span> أوافق على </span><strong onClick={handleClick} className="terms-hover"> الشروط والأحكام</strong>
                           </>
                          )}
                        </Typography>
                      }
                    />
                  </Box>
                </Stack>
              </Grid>
              <Grid item md={12} xs={12} sx={{ display: "flex" }}></Grid>
            </>
          )}
        </Grid>
      </Box>
    </>
  );
};

export default CustomerDetails;
